import { render, staticRenderFns } from "./ProductTypeShow.vue?vue&type=template&id=e2dae596&"
import script from "./ProductTypeShow.vue?vue&type=script&lang=js&"
export * from "./ProductTypeShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports